module.exports = __webpack_public_path__ + "img/弈剑女.75d44f35.png";